// M032 footer
function initFooterBlocks() {

    var $footerWithdrawContainerMobile = $(".footerWithdrawContainerMobile");
    if ($footerWithdrawContainerMobile.length > 0) {
        $footerWithdrawContainerMobile.empty();

        $(".footerBlockContainer .withdrawButton").each(function () {
            $footerWithdrawContainerMobile.append($(this).clone(true, true));
        });
    }

    if ($(".footerBlock").length > 0) {
        $(".footerBlock").each(function () {

            $(".footerBlock").find("ul").addClass("closed");
            //$(".footerBlock").first().find("ul").removeClass("closed");
            //$(".footerBlock").first().find(".footerBlockTitle").addClass("active");

            $(this).find(".footerBlockTitle").click(function () {

                if($(this).hasClass("active")){
                    $(this).removeClass("active");
                    $(this).siblings("ul").addClass("closed");
                }
                else{
                    $(".footerBlock").find("ul").addClass("closed");
                    $(".footerBlock").find(".footerBlockTitle").removeClass("active");
                    $(this).addClass("active");
                    $(this).siblings("ul").removeClass("closed");
                }
            });
            $(this).find(".footerBlockTitle").on("keydown", handleKeyDownForClick);
        });
    }

    if ($(".footerAdditionalLinks").length > 0) {

        $(".footerAdditionalLinks").each(function () {
            var $fal = $(this);

            $(".footerAdditionalLinks").find(".footerAdditionalLinksHead").click(function () {

                if (!$fal.hasClass("opened")) {

                    $fal.find(".footerAdditionalLinksContent").removeClass("absolute");
                    $fal.find(".footerAdditionalLinksContent").addClass("absolute");

                    $fal.addClass("opened");

                    var targetHeight = $fal.find(".footerAdditionalLinksContent").height() + $fal.height() + 20;

                    $fal.animate({
                            height: targetHeight
                        },
                        {
                            duration: 250,
                            easing: "swing",
                            complete: function () {
                                $fal.find(".footerAdditionalLinksContent").removeClass("absolute");
                                $fal.css("height", "auto");

                                $('html, body').animate({
                                    scrollTop: $(".footerAdditionalLinks").offset().top
                                }, 500);
                            }
                        }
                    );
                }
                else {
                    $fal.find(".footerAdditionalLinksContent").removeClass("absolute");
                    $fal.removeClass("opened");

                    $fal.animate({
                            height: $fal.children(".container").height()
                        },
                        {
                            duration: 500,
                            easing: "swing",
                            complete: function () {
                                $fal.css("height", "auto");
                            }
                        }
                    );
                }
            });
            $(".footerAdditionalLinks").find(".footerAdditionalLinksHead").on("keydown", handleKeyDownForClick);
        })
    }
}

function updateFooterBlocks() {

    return;

    //center footer blocks
    $(".footerBlockContainer").each(function(){

		if($(this).find(".footerBlock").length == 3){
			//center 3 blocks, not 4, not 2 or 1
			
			$(this).find(".footerBlock").css("margin-left", 0);

			$(".footerSublineTextLeft").css("margin-left", 0);
			$(".footerSublineTextRight").css("margin-left", 0);
			$(".footerSublineTextRight").css("margin-right", 0);

			if($(window).width() >= _breakpointMedium){

				var w = 0;
				var fw = 0;
				var ml = 0;
				if($(this).find(".footerBlock").length < 4) {                
					//calculate width of all blocks
					$(this).find(".footerBlock").each(function() {
						w += $(this).outerWidth();
					});
					if(w > 0){
						//calculate and set margin-left for first block
						fw = $(".footerBlockContainer").outerWidth()
						ml = Math.floor((fw - w) /2);
						$(this).find(".footerBlock").first().css("margin-left", ml + "px");
						
						//subline settings
						$(".footerSublineTextLeft").css("margin-left", ml + "px");
						$(".footerSublineTextRight").css("margin-left", $(".footerSublineTextLeft").width()+ml + "px");
						$(".footerSublineTextRight").css("margin-right", ml + "px");
					}            
				}
				else if($(this).find(".footerBlock").length == 5) {
					$(this).find(".footerBlock").each(function() {
						$(this).removeClass("col-md-3");
						$(this).removeClass("col-lg-3");
						$(this).removeClass("footerBlock20");
						$(this).addClass("footerBlock20");
					});
				}
			}
		}
    });
}
